<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmEnergyFlow from 'src/components/EnergyMonitoring/sections/EmEnergyFlow.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { normalizeEnergyConfig } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyFlow'> | undefined;
	export let staticPreview = false;
	export let useResponsiveDensity = false;

	$: config = normalizeEnergyConfig('dashEnergyFlow', energyConfig);
	$: initialVisibility = {
		showSupply: config.showSupply !== false,
		showRooms: config.showRooms !== false,
		showDevices: config.showDevices !== false,
	};
</script>

<Container type="glass" noScroll fullHeight>
	<EmEnergyFlow
		embedded
		{staticPreview}
		{initialVisibility}
		supplyMode={config.supplyMode}
		maxRoomNodes={useResponsiveDensity ? undefined : config.maxRoomNodes}
		maxDeviceNodes={useResponsiveDensity ? undefined : config.maxDeviceNodes}
	/>
</Container>
